import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SearchAndFilterToolbar, StatusBar } from "../common";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import useApi from "../../api";
import moment from 'moment';
import CustomerFilter from "./CustomerFilter";

import { Paginator } from "../../components/common";
import CustomerTable from "./CustomerTable";
import CreateCustomer from '../customer/createCustomer'
import { handleRetriveError } from "../../utils";

function CustomersMain() {
  const [openOrderFilterModal, setOpenOrderFilterModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openCustomerDrawer, setOpenCustomerDrawer] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const api = useApi();

  const [customerData, setCustomerData] = useState<any>();


  useEffect(() => {
    api.getCustomerList().then((response:any) => {
      setCustomerData(response);
    }, handleRetriveError)
  }, []);


  const changeStatus = (status: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("status", status);
    newParams.set("page", "1"); 
    setSearchParams(newParams);
  };

  const onDateRangeApply = (range: any) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", "1"); 

    const formattedStartDate = moment(range?.startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(range?.endDate).format('YYYY-MM-DD');

    newParams.set("created_at_before", formattedEndDate);
    newParams.set("created_at_after", formattedStartDate);
    setSearchParams(newParams);
  }


  useEffect(() => {
    if (!searchParams.get("page")) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", "1");
      setSearchParams(newParams);
    }
  }, []);

  const currentPage = searchParams.get("page");
  const currentStatus = searchParams.get("status");

  const onPageChange = (page: number | any) => {
    if (!page) {
      return;
    }
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", page.toString());
    setSearchParams(newParams);
  }

  const onSearch = (e: any) => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set("search", e.target.value)
    setSearchParams(newParams)
  }

  const onCustomerCreateButton = () => {
    setOpenCustomerDrawer(!openCustomerDrawer)
  }

  return (
    <PageBodyWrapper>
      <StatusBar 
        statusList={[]} 
        currentStatus={currentStatus || ''} 
        onChangeStatus={changeStatus} 
        buttonLabel="Add Customer"
        onButtonClick={onCustomerCreateButton}
      />

      <SearchAndFilterToolbar
        onDateRangeApply={onDateRangeApply}
        onFilterOpen={() => setOpenFilterModal(!openFilterModal)}
      />

    {openFilterModal && <CustomerFilter onClose={() => setOpenFilterModal(false)} />}

      <div className="px-2 overflow-x-auto">
        <CustomerTable customerData={customerData} />
      </div>

      <Paginator onPageChange={onPageChange} data={customerData} />

      <CreateCustomer
        isOpen={openCustomerDrawer}
        onClose={() => setOpenCustomerDrawer(false)}
      />

    </PageBodyWrapper>
  );
}

export default CustomersMain;
